import React from 'react'
import Partners from '../components/Sections/Partners';
import BannerVideo from "../assets/video/banner_video.mp4";

export default function Home() {
  return (
    <div>
        <div className='fixed top-0 left-0 w-full h-screen'>
          <div className='absolute h-screen w-full top-0 left-0 bg-black-alpha-70 z-1'></div>
          <video src={BannerVideo} autoPlay muted loop/>
        </div>
        <div className='h-screen'></div>
        <Partners/>
    </div>
  )
}
